@if (content) {
<category-header [variant]="category.cmsBlockHeaderVariant"
                 [category]="category"></category-header>
<!-- top outlet -->
<icms-outlet [components]=" content.topComponents"
             [allowOnly]=" ['category-landing-page-header', 'page-component-product-features']"
             [name]=" 'Category page / top section'">
</icms-outlet>
<!-- breadcrumbs / X, L-->
<div class="wrap"
     *ifSize="'XL'">
    <breadcrumbs class="block m-t-8 m-b-8"></breadcrumbs>
</div>
<!-- middle outlet -->
<icms-outlet [components]="content.middleComponents"
             [allowOnly]=" ['quick-links', 'text-header-variant', 'page-component-product-features']"
             [name]=" 'Category page / middle section'">
</icms-outlet>

<!-- listing -->
@if(enabledAc) {
<ac-product-listing class="p-b-8 block m-t-5 m-t-2-s m-t-2-m" />
} @else {
<product-listing [context]="'category'"
                 [listing]="categoryView.listing"></product-listing>
}

<!-- Bottom components -->
<ng-container *afterContentInit>
    <icms-outlet [components]=" content.bottomComponents"
                 [allowOnly]=" ['editorial-layout', 'page-component-product-features', 'editorial-faq', 'quick-links' ,'product-carousel']"
                 [name]=" 'Category page / bottom section'">
    </icms-outlet>
</ng-container>
<!-- breadcrumbs / S, M -->
<ng-container *afterContentInit>
    <div class="wrap"
         *ifSize="'SM'">
        <breadcrumbs class="block m-b-7 m-t-7"></breadcrumbs>
    </div>
</ng-container>
}
